// extracted by mini-css-extract-plugin
export default {"wrapper":"PostDetail_wrapper__FYwEZ","comment-detail":"PostDetail_comment-detail__q3V8+","post-detail":"PostDetail_post-detail__c+VMj"};